module.exports = __webpack_public_path__ + "img/s-bg.61454461.jpg";